module.exports = __webpack_public_path__ + "img/shortcut-booking-shipment.29a55183.svg";